import axios from '../../../commons/gdprcontrol-axios'

const legalBaseAliasSkeleton = {
  id: null,
  legal_base: null,
  organization: null,
  name: ''
}

const state = {
  legalBaseAlias: Object.assign({}, legalBaseAliasSkeleton)
}

const getters = {
  getLegalBaseAlias: state => state.legalBaseAlias
}

const actions = {
  fetchLegalBaseAlias: async ({ commit, dispatch }, legalBaseAliasId) => {
    return axios.get(`/api/legal_base_aliases/${legalBaseAliasId}/`)
      .then(response => {
        commit('setLegalBaseAlias', response.data)
      })
      .catch(error => {
        alert(`Failed to get legal base alias ${legalBaseAliasId} ID`)
        throw error
      })
  }
}

const mutations = {
  setLegalBaseAlias (state, legalBaseAlias) {
    state.legalBaseAlias = legalBaseAlias
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/legalBaseAlias/details.js